/* eslint-disable no-unused-vars */
import {API_URL, API_URL_V2, itemPerPage} from '../constants/index.js';
import {
    RESIDENT,
    RESIDENT_SUCCESS,
    RESIDENT_ERROR,
    ADD_RESIDENT,
    ADD_RESIDENT_SUCCESS,
    ADD_RESIDENT_ERROR,
    UPDATE_RESIDENT,
    UPDATE_RESIDENT_SUCCESS,
    UPDATE_RESIDENT_ERROR,
    DELETE_RESIDENT,
    DELETE_RESIDENT_SUCCESS,
    DELETE_RESIDENT_ERROR,
    GET_TAGS_RESIDENT,
    GET_TAGS_RESIDENT_ERROR,
    GET_TAGS_RESIDENT_SUCCESS,
    RESIDENT_BY_TAGS,
    RESIDENT_BY_TAGS_ERROR,
    RESIDENT_BY_TAGS_SUCCESS,
    CLEAN_RESIDENT,
    SYNC_RESIDENTS,
    SYNC_RESIDENTS_SUCCESS,
    SYNC_RESIDENTS_ERROR,
    SYNC_RESIDENTS_BY_COMMUNITY,
    SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS,
    SYNC_RESIDENTS_BY_COMMUNITY_ERROR
} from '../constants/residentConstants';
import {sweetAlert} from '../components/Alert/sweetAlert'

let message =''

//#region  GET RESIDENT
export function getCleanResident(data){
    return {
        type: CLEAN_RESIDENT,
        data: data
    }
};

export function getResident(data){
    return {
        type: RESIDENT,
        data: data
    }
};

export function getResidentSuccess(data){
    return{
        type: RESIDENT_SUCCESS,
        data: data
    }
};

export function getResidentError(data){
    return{
        type: RESIDENT_ERROR,
        data: data
    }
};

export function getALLResidents(){
    return dispatch => {
        dispatch(getResident());

        fetch(API_URL+'residents/residents',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    dispatch(getResidentSuccess(res))
                }
            )
            .catch(
                error => {
                    dispatch(getResidentError(error));
                }
            )
    }
};

export function getALLResidentsByCommunityID(communityId){
    return dispatch => {
        dispatch(getResident());
        fetch(API_URL+'residents/residents',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    let  residentsFilterNyCommunityId = [];

                    if(Array.isArray(res)){
                        residentsFilterNyCommunityId = res.filter(
                            item => {
                                return String(item.communityUID) === String(communityId)
                            }
                            )
                    }

                    dispatch(getResidentSuccess(residentsFilterNyCommunityId))
                }
            )
            .catch(
                error => {
                    dispatch(getResidentError(error));
                }
            )
    }
};

export function GetCleanResidents(){
    return dispatch => {
        dispatch(getCleanResident());
    }
};

export function getALLResidentsByCommunityIDPagination(communityId, currentPage){
    return dispatch => {
        dispatch(getResident());
        fetch(API_URL+'cms/residents/residents',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'communityid': communityId,
                    'page': currentPage,
                    'itemsperpage':itemPerPage
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    const residentData = res;
                    dispatch(getResidentSuccess(residentData))
                }
            )
            .catch(
                error => {
                    dispatch(getResidentError(error));
                }
            )
    }
};


export function getResidentsByCommunity(communityId){
    return dispatch => {
        dispatch(getResident());
        fetch(API_URL+'residents/residentsByCommunity',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'communityid':  communityId
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    dispatch(getResidentSuccess(res))
                }
            )
            .catch(
                error => {
                    dispatch(getResidentError(error));
                }
            )
    }
};
//#endregion

//#region  ADD RESIDENT
export function addResident(data){
    return {
        type: ADD_RESIDENT,
        data: data
    }
};

export function addResidentSuccess(data){
    return{
        type: ADD_RESIDENT_SUCCESS,
        data: data
    }
};

export function addResidentError(data){
    return{
        type: ADD_RESIDENT_ERROR,
        data: data
    }
};

export function AddResident(data, idCommunity){
    return dispatch => {
        dispatch(addResident());

        fetch(API_URL_V2+'residents/residents',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    message= 'Added Resident Successfully!!'
                    dispatch(addResidentSuccess(res))

                    sweetAlert('success', message,'alert_AddResident_Success');
                }
            )
            .catch(
                error => {
                    message = 'An ERROR has occurred when adding the resident'
                    dispatch(addResidentError(error));
                    sweetAlert('error', message,'alert_AddResident_Error');
                }
            )
    }
};

//#endregion

//#region  UPDATE RESIDENT
export  function updResident(data){
    return {
        type: UPDATE_RESIDENT,
        data: data
    }
};

export function updResidentSuccess(data){
    return{
        type: UPDATE_RESIDENT_SUCCESS,
        data: data
    }
};

export function updResidentError(data){
    return{
        type: UPDATE_RESIDENT_ERROR,
        data: data
    }
};

export function UpdResident(id,data,idCommunity){
    return async dispatch => {
        dispatch(updResident());

        let response = undefined;
         await fetch(API_URL_V2+'residents/residents/'+id,
            {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(
                res =>{
                    message= 'Resident Updated Successfully';
                    
                    dispatch(updResidentSuccess(data));

                    sweetAlert('success', message,'alert_UpdateResident_Success');

                    response = res;
                }
            )
            .catch(
                error => {
                    message= 'An error had occurred when trying to update the resident';
                    dispatch(updResidentError(error));

                    sweetAlert('error', message,'alert_UpdateResident_Error');
                }
            )

            return response;
    }
};
//#endregion

//#region  DELETE RESIDENT
export function delResident(data){
    return {
        type: DELETE_RESIDENT,
        data: data
    }
};

export function delResidentSuccess(data){
    return{
        type: DELETE_RESIDENT_SUCCESS,
        data: data
    }
};

export function delResidentError(data){
    return{
        type: DELETE_RESIDENT_ERROR,
        data: data
    }
};

export function DelResident(id){
    return dispatch => {
        dispatch(delResident());
        
        fetch(API_URL+'/residents/residents/'+id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(
                res =>{
                    message='The resident has been deleted successfully ';
                    dispatch(delResidentSuccess(id))

                    sweetAlert('success', message,'alert_DeleteResident_Success');
                    
                }
            )
            .catch(
                error => {

                    message='An error had occurred when trying  to delete the resident ';
                    dispatch(delResidentError(error));
                    sweetAlert('error', message,'alert_DeleteResident_Error');
                }
         )
    }
};
//#endregion


//#region  GET RESIDENT TAGS
export function getResidentTags(data){
    return {
        type: GET_TAGS_RESIDENT,
        data: data
    }
};

export function getResidentTagsSuccess(data){
    return{
        type: GET_TAGS_RESIDENT_SUCCESS,
        data: data
    }
};

export function getResidentTagsError(data){
    return{
        type: GET_TAGS_RESIDENT_ERROR,
        data: data
    }
};

export function GetResidetTags(){
    return dispatch => {
        
        dispatch(getResidentTags());
        
        fetch(API_URL+'/residents/getTags',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(
                res =>{

                    dispatch(getResidentTagsSuccess(res));                    
                }
            )
            .catch(
                error => {
                    dispatch(getResidentTagsError(error));
                }
         )
    }
};
//#endregion

//#region  GET RESIDENT BY TAGS
export function getResidentByTags(data){
    return {
        type: RESIDENT_BY_TAGS,
        data: data
    }
};

export function getResidentByTagsSuccess(data){
    return{
        type: RESIDENT_BY_TAGS_SUCCESS,
        data: data
    }
};

export function getResidentByTagsError(data){
    return{
        type: RESIDENT_BY_TAGS_ERROR,
        data: data
    }
};

export function GetResidentsByTags(tags){
    return dispatch => {
        dispatch(getResidentByTags());

        fetch(API_URL+'residents/getResidentsByTags',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Tags':tags,
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    dispatch(getResidentByTagsSuccess(res))
                }
            )
            .catch(
                error => {
                    dispatch(getResidentByTagsError(error));
                }
            )
    }
};
//#endregion GET RESIDENT BY TAGS


//#region  GET RESIDENT ALL COMMUNITY
//Use same dispatchers constants as get resident by tags
export function GetResidentsAllCommunities(){
    return dispatch => {
        dispatch(getResidentByTags());

        fetch(API_URL+'residents/residents',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    dispatch(getResidentByTagsSuccess(res))
                }
            )
            .catch(
                error => {
                    dispatch(getResidentByTagsError(error));
                }
            )
    }
};
//#endregion GET RESIDENT BY TAGS

//#region  SYNC RESIDENTS
export function syncResidents(data){
    return {
        type: SYNC_RESIDENTS,
        data: data
    }
};

export function syncResidentsSuccess(data){
    return{
        type: SYNC_RESIDENTS_SUCCESS,
        data: data
    }
};

export function syncResidentsError(data){
    return{
        type: SYNC_RESIDENTS_ERROR,
        data: data
    }
};

export function SyncResidents(data){
    return dispatch => {
        dispatch(syncResidents());

        fetch(API_URL+'residents/syncCLResident',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                }
            })
            .then(res => res.json())
            .then(
                res =>{
                    message= 'Sync Residents Successfully!!'
                    dispatch(syncResidentsSuccess(res))

                    sweetAlert('success', message,'alert_SyncResidents_Success');
                }
            )
            .catch(
                error => {
                    message = 'An ERROR has occurred when synchronized residents'
                    dispatch(syncResidentsError(error));
                    sweetAlert('error', message,'alert_SyncResidents_Error');
                }
            )
    }
};

//#endregion


//#region  SYNC RESIDENTS BY COMMUNITY
export function syncResidentsByCommunity(data){
    return {
        type: SYNC_RESIDENTS_BY_COMMUNITY,
        data: data
    }
};

export function syncResidentsByCommunitySuccess(data){
    return{
        type: SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS,
        data: data
    }
};

export function syncResidentsByCommunityError(data){
    return{
        type: SYNC_RESIDENTS_BY_COMMUNITY_ERROR,
        data: data
    }
};

export function SyncResidentsByCommunity(communityId){
    return dispatch => {
        dispatch(syncResidentsByCommunity());

        fetch(API_URL+'residents/fullSyncResidents',
            {
                method: 'POST',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': communityId
                }
            })
            .then(
                res =>{
                    message= 'Sync Residents Successfully!!'
                    dispatch(syncResidentsByCommunitySuccess(res))
                    sweetAlert('success', message,'alert_SyncResidents_Success');
                }
            )
            .catch(
                res =>{
                    message= 'Sync Residents Successfully!!'
                    dispatch(syncResidentsByCommunitySuccess(res))
                    sweetAlert('success', message,'alert_SyncResidents_Success');
                }
            )
    }
};

//#endregion
